import { ReactNode } from 'react';
import { Sidebar } from './navigation/Sidebar';
import { MobileNav } from './navigation/MobileNav';
import { MobileFab } from './navigation/MobileFab';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Desktop Sidebar - Hidden on mobile */}
      <Sidebar />

      {/* Mobile Navigation - Hidden on desktop */}
      <MobileNav />

      {/* Main Content */}
      <main className="px-4 py-6 md:ml-60 md:px-6 md:py-8 pt-20 pb-20 md:pt-6 md:pb-8">
        {children}
      </main>

      {/* Mobile-only floating action button (Add Transaction) */}
      <MobileFab />
    </div>
  );
}
